import React from 'react';
import { Container, Row, Col, Form, Button,  } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NextCasesByType = () => {
  return (
    <Container className="mt-4" style={{ maxWidth: '600px', marginLeft: '0px' }}>
      <Form className="p-4 border rounded" style={{ borderTop: '5px solid rgb(0, 123, 255)' }}>
        <fieldset>
          <legend>Parameters</legend>

          {/* Start Date Input */}
          <Form.Group as={Row} controlId="cases-remakes-start-date" className="mb-4">
            <Form.Label column sm="4">
              Start Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control 
                type="date" 
                id="cases-remakes-start-date" 
                name="start_date" 
                required 
                defaultValue="2024-09-01" 
              />
            </Col>
          </Form.Group>

          {/* End Date Input */}
          <Form.Group as={Row} controlId="cases-remakes-end-date" className="mb-4">
            <Form.Label column sm="4">
              End Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control 
                type="date" 
                id="cases-remakes-end-date" 
                name="end_date" 
                required 
                defaultValue="2024-09-30" 
              />
            </Col>
          </Form.Group>

          {/* Accounts Selection */}
          <Form.Group as={Row} controlId="cases_remakes_practice" className="mb-4">
            <Form.Label column sm="4">Accounts</Form.Label>
            <Col sm="8">
              <Form.Select 
                name="practice" 
                id="cases_remakes_practice" 
              >
                <option value="0">All</option>
                <option value="144545">2ingis s.a.</option>
                <option value="124046">Bhandal Dental Practice(Amrik B)</option>
                <option value="71165">Bhandal Dental Practice(Chetan Mathias)</option>
                <option value="87266">Bhandal Dental Practice(Dr Ria)</option>
                <option value="111501">Bhandal Dental Practice(Gurung Dipendra)</option>
                <option value="102121">Bhandal Dental Practice(Periane Arioli)</option>
                <option value="89429">Bhandal Dental Practice(Sagar Gurung)</option>
                <option value="144583">Bhandal Dental Surgery</option>
                <option value="78951">Bilston Dental Care Wolverhampton</option>
                <option value="88036">Wood End Dental Surgery</option>
              </Form.Select>
            </Col>
          </Form.Group>

          {/* Account Tags */}
          <Form.Group as={Row} controlId="report_cases_remakes_external_account_tags" className="mb-4">
            <Form.Label column sm="4">Account Tags</Form.Label>
            <Col sm="8">
              <Form.Select 
                name="tags" 
                id="report_cases_remakes_external_account_tags"
            
                style={{  }}
              >
                <option value="">No filter</option>
                <option value="a-practices">a-practices</option>
                <option value="bhandal">bhandal</option>
                <option value="coventry-dental">coventry-dental</option>
                <option value="dental-beauty">dental-beauty</option>
                <option value="murray-dental-">murray-dental-</option>
                <option value="swissmeda">swissmeda</option>
              </Form.Select>
              
            </Col>
          </Form.Group>

          {/* Type Selection */}
          <Form.Group as={Row} controlId="cases_remakes_type" className="mb-4">
            <Form.Label column sm="4">Type</Form.Label>
            <Col sm="8">
              <Form.Select 
                name="type" 
                id="cases_remakes_type"
              >
                <option value="">All</option>
                <option value="5">DENTIST WANTS A DIFFERENT SHADE</option>
                <option value="2">NEEDS ADJUSTING</option>
                <option value="4">NEXT PROCEDURE</option>
                <option value="1">REMAKE</option>
                <option value="3">REPAIR</option>
              </Form.Select>
            </Col>
          </Form.Group>

          {/* Group By Selection (Hidden) */}
          <Form.Group as={Row} controlId="cases_remakes_group_by" className="mb-4" style={{ display: 'none' }}>
            <Form.Label column sm="4">Group By</Form.Label>
            <Col sm="8">
              <Form.Select name="group_by" id="cases_remakes_group_by">
                <option value=""></option>
                <option value="user">User</option>
              </Form.Select>
            </Col>
          </Form.Group>

          {/* Include Completed Tasks Checkbox */}
          {/* <Form.Group as={Row} controlId="cases_remakes_include_tasks" className="mb-4">
            <Col sm="4">
              <Form.Label style={{ position: 'relative', top: '-7px' }}>Options</Form.Label>
            </Col>
            <Col sm="8">
              <FormCheck 
                type="checkbox" 
                name="include_tasks" 
                id="cases_remakes_include_tasks" 
                value="1"
                label="Include Completed Tasks"
                style={{ marginLeft: '0px', position: 'relative', top: '-4px' }}
              />
            </Col>
          </Form.Group> */}

          {/* Format Selection */}
          <Form.Group as={Row} controlId="report_cases_remakes_format" className="mb-4">
            <Form.Label column sm="4">
              Format <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Select 
                name="format" 
                id="report_cases_remakes_format"
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </Form.Select>
            </Col>
          </Form.Group>

          {/* Submit Button */}
          <Form.Group as={Row}>
            <Col sm={{ span: 8, offset: 4 }}>
              <Link to="/AddNextCasesByDesp">
                <Button
                  id="pay-per-task-submit"
                  type="button"
                  variant="primary"
                  className="w-100 mt-2"
                  style={{
                    backgroundColor: '#004aad',
                    borderColor: '#004aad',
                    marginTop: '10px',
                  }}
                >
                  Run
                </Button>
              </Link>
            </Col>
          </Form.Group>
        </fieldset>
      </Form>
    </Container>
  );
};

export default NextCasesByType;
